<template>
    <div class="tle-row c-information">
        <div class="tle-col c-information__label" :class="{'four-fifth': !!$slots.default}">
            <icon file="alert-circle" size="16" />
            <p>{{ title }}</p>
        </div>
        <div v-if="!!$slots.default" class="tle-col one-fifth priorite-wrapper">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
	props: {
		title: { defalut: "" }
	}
};
</script>

<style lang="stylus">
@import '../../assets/css/app'
@import '../../assets/css/page'

.c-information
  background #eee
  border-radius 3px
  overflow hidden
  font-weight bold

  &__label
    display flex

    .icon
      flex-shrink 0
      margin-right 5px

  .priorite-wrapper
    position relative
    background main_color
    color #fff
    display flex
    flex-direction column
    justify-content center
    padding-left 30px

    &::before
      position absolute
      left -1px
      top 0
      bottom 0
      display block
      width 20px
      content ""
      background no-repeat left/cover
      background-image url("data:image/svg+xml,%0A%3Csvg width='22px' height='84px' viewBox='0 0 22 84' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cpolygon id='Path-2' fill='%23EEEEEE' points='0.5546875 -0.046875 21.5390625 40.953125 0.5546875 83.1780502'%3E%3C/polygon%3E%3C/g%3E%3C/svg%3E")
</style>